<template>
	<div>
		<section-row
			v-for="sectionRow in rowSections"
			:section-row="sectionRow"
			:key="sectionRow.id"
		/>
	</div>
</template>

<script>
import { mapState } from "vuex";
import sectionRow from "./section-row";

export default {
	name: "Sections",
	components: {
		sectionRow
	},
	computed: {
		...mapState({
			rowSections: state => state.Home.rowsSections
		})
	},
	created() {
		this.buildSectionsRows();
	},
	methods: {
		buildSectionsRows() {
			const sections = CONFIG.HOME_SECTION;

			const heroPromoSection = sections.landing_page_sections.find(section => section.position == "promo-hero") || {};
			this.$store.dispatch("Home/setHeroPromo", heroPromoSection);

			const topSection = sections.landing_page_sections.find(section => section.position == "top") || {};
			this.$store.dispatch("Home/saveTopSection", topSection);

			let topSections = sections.landing_page_sections.filter(section => section.position.startsWith("top-"));
			topSections = _.sortBy(topSections, section => section.position);

			let bottomSections = sections.landing_page_sections.filter(section => section.position.startsWith("bottom-"));
			bottomSections = _.sortBy(bottomSections, section => section.position);

			const rowSections = [topSections, bottomSections];
			this.$store.dispatch("Home/saveRowsSections", rowSections);
		}
	}
};
</script>
